module.exports = __webpack_public_path__ + "static/esper_hardware_cloud-47d6513a6a1efd9c10cccc36c5a24974.jpg";